import jobIcon from "../../assets/images/resume/job-icon.svg";
import { Col, Image, Row } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Header = ({ isLoading, resume }) => {
  const navigate = useNavigate();
  const [resumeHeader, setResumeHeader] = useState({
    job_title: "",
    job_sub_category: "",
    job_family: "",
    region: "",
    education_level: "",
    career_level: "",
    experience: null,
    industry: "",
  });
  useEffect(() => {
    setResumeHeader({
      job_title: resume?.job_title,
      job_sub_category: resume?.job_sub_category,
      job_family: resume?.job_family,
      region: resume?.region,
      education_level: resume?.education_level,
      career_level: resume?.career_level,
      experience: resume?.years_experience,
      industry: resume?.industry,
      description: resume?.resume_long_description,
    });
  }, [resume]);
  return (
    <div className="left-content">
      {isLoading ? (
        <div className="loading">
          <div className="header">
            <div className="job-title">
              <div className="job-icon shimmer"></div>
              <div className="title">
                <h4 className="heading-4 shimmer"> </h4>
                <p className="paragraph-small-regular shimmer"></p>
              </div>
            </div>
          </div>
          <Row className="job-description d-flex">
            <div>
              <Row className="justify-content-between">
                <Col md={4} className="mb-4">
                  <p className="resume-detail-header mb-1">Career level:</p>
                  <h6 className="heading-6 shimmer"> </h6>
                </Col>
                <Col md={4} className="mb-4">
                  <p className="resume-detail-header mb-1">Experience</p>
                  <h6 className="heading-6 shimmer"> </h6>
                </Col>
                <Col md={4} className="mb-4">
                  <p className="resume-detail-header mb-1">Job Sub Category</p>
                  <h6 className="heading-6 shimmer"> </h6>
                </Col>
                <Col md={4} className="mb-4">
                  <p className="resume-detail-header mb-1">Job Family:</p>
                  <h6 className="heading-6 shimmer"> </h6>
                </Col>
                <Col md={4} className="mb-4">
                  <p className="resume-detail-header mb-1">Region</p>
                  <h6 className="heading-6 shimmer"> </h6>
                </Col>
                <Col md={4} className="mb-4">
                  <p className="resume-detail-header mb-1">Education Level:</p>
                  <h6 className="heading-6 shimmer"> </h6>
                </Col>
              </Row>
            </div>
            <div>
              <p className="resume-detail-header mb-1">Description</p>
              <p className="pargraph-small-regular desription">
                <div className="block-1 shimmer"></div>
                <div className="block-2 shimmer"></div>
                <div className="block-3 shimmer"></div>
              </p>
            </div>
          </Row>
        </div>
      ) : (
        <div>
          <div className="header">
            <div className="job-title">
              <div className="job-icon">
                <Image src={jobIcon} />
              </div>
              <div className="title">
                <h4 className="heading-4">{resumeHeader?.job_title}</h4>
                <p className="paragraph-small-regular">
                  {resumeHeader?.industry}
                </p>
              </div>
            </div>
          </div>
          <Row className="job-description d-flex">
            <div>
              <Row className="justify-content-between">
                <Col md={4} sm={6} className="mb-4">
                  <p className="resume-detail-header mb-1">Career level:</p>
                  <h6 className="heading-6 ">{resumeHeader?.career_level}</h6>
                </Col>
                <Col md={4} sm={6} className="mb-4">
                  <p className="resume-detail-header mb-1">Experience</p>
                  <h6 className="heading-6 ">
                    {resumeHeader?.experience} year
                  </h6>
                </Col>
                <Col md={4} sm={6} className="mb-4">
                  <p className="resume-detail-header mb-1">Job Sub Category</p>
                  <h6 className="heading-6 ">
                    {resumeHeader?.job_sub_category}
                  </h6>
                </Col>
                <Col md={4} sm={6} className="mb-4">
                  <p className="resume-detail-header mb-1">Job Family:</p>
                  <h6 className="heading-6 ">{resumeHeader?.job_family}</h6>
                </Col>
                <Col md={4} sm={6} className="mb-4">
                  <p className="resume-detail-header mb-1">Region</p>
                  <h6 className="heading-6 ">{resumeHeader?.region}</h6>
                </Col>
                <Col md={4} sm={6} className="mb-4">
                  <p className="resume-detail-header mb-1">Education Level:</p>
                  <h6 className="heading-6 ">
                    {resumeHeader?.education_level}
                  </h6>
                </Col>
              </Row>
            </div>
            <div>
              <p className="resume-detail-header mb-1">Description</p>
              <p className="pargraph-small-regular">
                {resumeHeader?.description}
              </p>
            </div>
          </Row>
        </div>
      )}
    </div>
  );
};

export default Header;
